import type { PatchCaseUpdateBody } from '@packages/clients';

import type { FailCodeData } from './types';

import { StsBackendOperation } from '../../../sts-backend-operation';
import { buildFailCodeUpdateBody } from '../helpers';

/** Parameters for updating fail code fields on a techline case. */
export type UpdateFailCodeParams = {
    /** The case number to update. */
    caseNumber: string;

    /** The fail code field values to set. */
    failCodeData: FailCodeData;

    /** The retailer number associated with the case. */
    retailerNumber: string | undefined;

    /** The username making the update. */
    username: string;

    /** The VIN associated with the case. */
    vin: string | undefined;
};

/**
 * Update the fail code fields on a techline case. Builds the update
 * payload and calls the NorthStar draft case API. The optimistic UI
 * state management (showing the update immediately) is handled by the
 * calling hook, not this operation.
 */
export class UpdateFailCode extends StsBackendOperation {
    /**
     * Build the fail code payload and persist it via the API.
     *
     * @param params - the fail code data and identity fields
     */
    async exec(params: UpdateFailCodeParams): Promise<void> {
        const updateBody = buildFailCodeUpdateBody(params) as PatchCaseUpdateBody;
        await this.client.updateCase({ updateBody });
    }
}
